import { ModelSagres } from "@/types/model-sagres";

export interface UgJson {
  id: number;
  nmNome: string;
  nmSigla: number;
  codUgSagres: string;
  urlTransparencia: string;
  hashPortal: string;
}
   
export class Ug extends ModelSagres {
  id: number;
  nmNome: string;
  nmSigla: number;
  codUgSagres: string;
  urlTransparencia: string;
  hashPortal: string;

  /**
   * @param obj
   */
  constructor(obj?: UgJson) {
    super();
    if (obj) {
      this.id = obj.id;
      this.nmNome = obj.nmNome;
      this.nmSigla = obj.nmSigla;
      this.codUgSagres = obj.codUgSagres;
      this.hashPortal = obj.hashPortal;
      this.urlTransparencia = obj.urlTransparencia;
    }
  }
}